module.exports = __webpack_public_path__ + "images/c01bf724befd009f7ba2232af211e54d.jpg";